import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { BellRing } from "lucide-react";
import { apiClient } from "@/lib/apiClient";

const chf = (v, c = "CHF") => `${c} ${Number(v || 0).toLocaleString("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmt = (d) => (d ? new Date(d).toLocaleDateString("de-CH") : "–");

/** Anstehende Verlängerungen (Verträge mit Enddatum + Jahres-Abos) – Grundlage der täglichen Erinnerung (Glocke + E-Mail). */
export function UpcomingRenewalsCard({ companyId, days = 60 }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!companyId) return;
    apiClient.get(`/companies/${companyId}/subscriptions-overview/upcoming-renewals`, { params: { days } }).then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [companyId, days]);
  if (!items) return null;
  return (
    <Card className="p-4 border border-slate-200 bg-white" data-testid="upcoming-renewals-card">
      <div className="flex items-start gap-2 mb-2">
        <BellRing className="h-4 w-4 text-slate-700 mt-0.5" />
        <div>
          <div className="text-sm font-medium text-slate-900">Anstehende Verlängerungen (nächste {days} Tage)</div>
          <div className="text-[11px] text-slate-500">Sie werden automatisch erinnert: Verträge 45 und 14 Tage vor Laufzeitende, Jahres-Abos 30 Tage vor der erwarteten Abbuchung, Kündigungsfristen 30 und 7 Tage vorher – in der App und per E-Mail.</div>
        </div>
      </div>
      {items.length === 0 ? <div className="text-xs text-slate-500" data-testid="upcoming-renewals-empty">Keine Verlängerungen in den nächsten {days} Tagen.</div> : (
        <table className="w-full text-xs">
          <thead><tr className="text-left text-slate-500 border-b border-slate-100"><th className="py-1">Was</th><th>Partner</th><th className="text-right">Betrag</th><th className="text-right">Verlängert am</th><th>Kündigung</th></tr></thead>
          <tbody>
            {items.map((it) => (
              <tr key={`${it.kind}-${it.id}`} className="border-b border-slate-50" data-testid={`renewal-row-${it.kind}-${it.id}`}>
                <td className="py-1"><a href={it.action_url} className="text-slate-800 hover:underline">{it.title}</a> <span className="text-[10px] text-slate-400">{it.kind === "contract" ? "Vertrag" : "Jahres-Abo"}</span></td>
                <td className="text-slate-600">{it.partner || "–"}</td>
                <td className="text-right tabular-nums">{it.amount != null ? chf(it.amount, it.currency) : "–"}</td>
                <td className={`text-right tabular-nums ${it.days <= 14 ? "text-rose-700 font-medium" : "text-slate-700"}`}>{fmt(it.date)} <span className="text-slate-400">({it.days} T.)</span></td>
                <td>{it.kind === "contract" ? (it.notice_deadline ? (it.notice_open ? <span className="text-amber-700">bis {fmt(it.notice_deadline)} möglich</span> : <span className="text-rose-700">Frist abgelaufen</span>) : <span className="text-slate-400">keine Frist hinterlegt</span>) : <span className="text-slate-400">beim Anbieter kündigen</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
  );
}
